import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-915b9b3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "service-wrap pt-20 pb-20" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row mb-5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12 text-center" }, [
    /*#__PURE__*/_createElementVNode("h2", { class: "section-title" }, "Nos Formations"),
    /*#__PURE__*/_createElementVNode("p", { class: "section-subtitle" }, "Découvrez nos différentes filières et niveaux d'études")
  ])
], -1))
const _hoisted_4 = {
  key: 0,
  class: "row"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 text-center py-5" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "spinner-border text-primary",
    role: "status"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Chargement...")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "mt-3" }, "Chargement des formations...")
], -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "row"
}
const _hoisted_8 = { class: "formation-card" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "formation-icon-wrapper" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-education formation-icon" })
], -1))
const _hoisted_10 = { class: "formation-content" }
const _hoisted_11 = { class: "formation-title" }
const _hoisted_12 = { class: "formation-niveau" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-level" }, null, -1))
const _hoisted_14 = {
  key: 0,
  class: "col-12 text-center py-5"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "no-data" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-search" }),
  /*#__PURE__*/_createElementVNode("h4", null, "Aucune formation disponible"),
  /*#__PURE__*/_createElementVNode("p", null, "Il n'y a pas de formation à afficher pour le moment.")
], -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = {
  key: 2,
  class: "mt-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filiereNiveaux, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "col-xl-3 col-lg-4 col-md-6 mb-4",
                key: index
              }, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("h5", _hoisted_11, _toDisplayString(item.filiere?.libelle || 'Non spécifié'), 1),
                    _createElementVNode("div", _hoisted_12, [
                      _hoisted_13,
                      _createElementVNode("span", null, _toDisplayString(item.niveau?.libelle || 'Non spécifié'), 1)
                    ])
                  ])
                ])
              ]))
            }), 128)),
            (!_ctx.isLoading && _ctx.filiereNiveaux.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
              : _createCommentVNode("", true)
          ])),
      (_ctx.totalPages > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createVNode(_component_PaginationComponent, {
              page: _ctx.page,
              totalPages: _ctx.totalPages,
              totalElements: _ctx.totalElements,
              limit: _ctx.limit,
              onPaginate: _ctx.handlePaginate
            }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}